import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useBusinessContext } from '@/context/BusinessContext';

interface SubscriptionRequiredRouteProps {
  children: React.ReactNode;
  fallbackPath?: string;
}

/**
 * Route guard that requires authentication and waits for business data to load.
 * Subscription check removed - payment is no longer required before accessing the app.
 */
const SubscriptionRequiredRoute: React.FC<SubscriptionRequiredRouteProps> = ({
  children,
}) => {
  const { user, loading: authLoading } = useAuth();
  const { loadingBusinesses } = useBusinessContext();

  // Return null while loading - GlobalLayout is already showing navbar/sidebar
  // so we don't want to show a full page skeleton inside the content area
  if (authLoading || loadingBusinesses) {
    return null;
  }

  // Not authenticated - redirect to sign in
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
};

export default SubscriptionRequiredRoute;
